import React from "react";
import { useSelector } from "react-redux";
import { FaCheck } from "react-icons/fa";
import CourseInformationForm from "./CourseForm/CourseInformationForm";
import CourseBuilderForm from "./CourseBuilderForm/CourseBuilderForm2";
import PublishCourse from "./PublishCourseBuilder/PublishCourse";

function RenderSteps(props) {
  const { step } = useSelector((state) => state.course);

  const steps = [
    {
      id: 1,
      title: "Course Information",
    },
    {
      id: 2,
      title: "Course Builder",
    },
    {
      id: 3,
      title: "Publish",
    },
  ];

  return (
    <div className="">
      <div className="w-full justify-center relative flex gap-x-40 max-[450px]:gap-x-[6.2rem]">
        {steps.map((item) => {
          return (
            //
            <div className="relative cursor-pointer">
              <div key={item.id}>
                <div
                  className={`rounded-full w-10 h-10 text-center flex justify-center items-center ${
                    step === item.id
                      ? "bg-yellow-900 border-yellow-50 border-dashed border text-yellow-50"
                      : `border-richblack-700 ${step > item.id ? "bg-yellow-25" : "bg-richblack-800"} text-richblack-300`
                  }`}>
                  {step > item.id ? <FaCheck className="text-richblack-900" /> : <span className="">{item.id}</span>}
                </div>
              </div>
              {/* {
                // item.id !== steps.length ? () : ()
               } */}
               {item.id !== steps.length && item.id !== 0 && (
              <div
                className={`absolute top-1/2 left-10 h-0.5 w-40 max-[450px]:w-[6.2rem] border-dashed border ${
                  step >= item.id + 1 ?
                     "bg-yellow-50"
                    : "bg-richblack-700"
                }`}
              />
            )}
            </div>
          );
        })}
      </div>
      <div className="w-full justify-center relative flex gap-x-24 max-[450px]:gap-x-14 -ml-4 mt-2 mb-10">
        {steps.map((item) => {
          return (
            <>
              <div key={item.id} className={`text-center flex justify-center items-center ${
                    step === item.id
                      ? " text-richblack-50"
                      : "text-richblack-200"
                  }`}>
                <p>{item.title}</p>
              </div>
            </>
          );
        })}
      </div>

      {step === 1 && <CourseInformationForm />}

      {step === 2 && <CourseBuilderForm />}

      {step === 3 && <PublishCourse />} 
    </div>
  );
}

export default RenderSteps;